
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '20260730JJRW';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    // {
    //   title: '年度标杆',
    //   path: `/${baseUrl}/newsMain`,
    //   id: 1,
    // },
    {
      title: '相关新闻',
      path: `/${baseUrl}/news`,
      id: 2,
    },
    // {
    //   title: '人物寻访',
    //   path: `/${baseUrl}/newsTwo`,
    //   id: 4,
    // },
    {
      title: '评选规则',
      path: `/${baseUrl}/rules`,
      id: 5,
    },
    {
      title: '正在报名',
      path: `/${baseUrl}/apply`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2025-2026十大重庆经济年度人物评选',
      url: location.href,
      subtitle: `奋进新征程 建设新重庆`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2025-2026十大重庆经济年度人物评选',
        subtitle: `奋进新征程 建设新重庆`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
